import React from "react";

// Small badge showing the format a synced league is valued in (1QB / SF / TEP).
// Helps users read the Multi-League Portfolio / Power Rankings in "Auto" mode.
const LABELS = { "1qb": "1QB", superflex: "SF", tep: "TEP" };
const FULL = { "1qb": "Single QB League", superflex: "Super Flex League", tep: "TE Premium League" };
const COLORS = {
  "1qb": { c: "var(--text-2)", b: "var(--border)" },
  superflex: { c: "#A78BFA", b: "rgba(167,139,250,0.4)" },
  tep: { c: "var(--amber)", b: "rgba(245,158,11,0.4)" },
};

export default function FormatBadge({ format, className = "" }) {
  const key = String(format || "1qb").toLowerCase();
  const label = LABELS[key] || key.toUpperCase();
  const { c, b } = COLORS[key] || COLORS["1qb"];
  return (
    <span
      data-testid={`format-badge-${key}`}
      title={FULL[key] || `${label} League`}
      className={`inline-flex items-center font-mono text-[9px] font-semibold leading-none tracking-[0.12em] rounded-sm px-1.5 py-0.5 align-middle ${className}`}
      style={{ color: c, border: `1px solid ${b}`, background: "rgba(255,255,255,0.04)" }}
    >
      {label}
    </span>
  );
}
